function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.88 11.506C19.995 7.924 16.267 5.5 12 5.5c-4.268 0-7.997 2.425-9.88 6.006-.16.31-.16.678 0 .988C4.005 16.076 7.733 18.5 12 18.5c4.268 0 7.997-2.425 9.88-6.006.16-.31.16-.678 0-.988zM12 16.875c-2.761 0-5-2.183-5-4.875s2.239-4.875 5-4.875S17 9.308 17 12a4.815 4.815 0 01-1.464 3.448A5.063 5.063 0 0112 16.875zm0-8.125a3.39 3.39 0 00-.879.128 1.59 1.59 0 01-.163 2.106 1.695 1.695 0 01-2.16.16c-.373 1.341.172 2.766 1.357 3.541a3.393 3.393 0 003.876-.12 3.193 3.193 0 001.125-3.618c-.46-1.316-1.73-2.2-3.156-2.197z"
});

function SvgPasswordEyeShowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPasswordEyeShowinline;